/**
 * @param {string} selector
 * @return {HTMLElement}
 */
export function $(selector) {
    return document.querySelector(selector);
}

/**
 * @param {string} selector
 * @return {HTMLElement[]}
 */
export function $$(selector) {
    return Array.from(document.querySelectorAll(selector));
}

/**
 * Génère une classe à partir de différentes variables
 *
 * @param  {...string|null} classnames
 */
export function classNames(...classnames) {
    return classnames.filter((classname) => classname !== null && classname !== false).join(" ");
}

/**
 * Convertit les données d'un formulaire en objet JavaScript
 *
 * @param {HTMLFormElement} form
 * @return {{[p: string]: string}}
 */
export function formDataToObj(form) {
    return Object.fromEntries(new FormData(form));
}

/**
 * Insert un nouvelle elemnent dans le DOM
 * @param newNode
 * @param existingNode
 */
export function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}
